import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
//import usMsaAll from '../../../../components/Map/cb_2018_us_cbsa_20m_wkid102004.json1'
import { useGeoState } from '../../../../components/GeoProvider'
import LinkButton from '../../../../components/LinkButton'
import Tag from '../../../../components/Tag'
import statesMap from '../../../../utils/stateMap'
import getVectorImage from '../../../../utils/getVectorImage'
import styles from './CbsaStats.module.scss'
import statStyles from './CbsaStat.module.scss'

import Tooltip from '../../../../components/Tooltip'
import Content from '../../../../components/Content'

const CbsaStat = ({ cbsaJson, cbsa, chartRef, mapOptions, toggleEnabled }) => {
  const history = useHistory()
  const changePercentage = parseFloat(cbsa.change_percentage)
  const forecastValue = parseFloat(cbsa.forecast_value)
  const isChanged = parseFloat(cbsa.change_percentage) > 0 ? true : false
  const valueStr = changePercentage.toFixed(2)
  const needsPad = parseFloat(valueStr) < 10
  const padded = (needsPad ? '\u2007' : '') + valueStr
  const states = statesMap()
  let statename = `${cbsa.name.substring(0, 10)} (${cbsa.parent})`

  const handleMouseOver = (element) => {
    debugger
    let chartCurrent = chartRef.current.chart
    if (chartCurrent !== undefined && chartCurrent !== null) {
      const identifier = element.attributes['geo_id'].value
      const parent = element.attributes['parent'].value

      const point = chartCurrent.series[1].points.find(function (point) {
        const geoIdvalue = point.geoid === identifier

        if (!geoIdvalue) return false

        if (point.parent.includes(',')) {
          const geoArray = point.parent.split(',')
          if (geoArray.includes(parent)) {
            return true
          }
        } else {
          if (point.parent === parent) {
            return true
          }
        }

        return false
      })

      if (point) {
        const originalGeoParent = point.parent
        point.update({ parent: parent }, false) // update without redraw
        chartCurrent.tooltip.refresh(point)
        point.update({ parent: originalGeoParent }, false) // restore original
      }       
    }
  }

  return (
    <div className={statStyles.base}>
      <div className={statStyles.columnState} title={cbsa.name}>
        <LinkButton
          className={statStyles.button}
          onMouseOver={(e) => handleMouseOver(e.target)}
          onClick={() => {
            debugger
            toggleEnabled
              ? history.push(
                  `/FLUMSADashboard/${cbsa.parent}/MSA/${cbsa.identifier}`
                )
              : history.push(`/forecasts/Flumap#metro-${cbsa.identifier}`)
          }}
          title={cbsa.name}
          parent={cbsa.parent}
          geo_id={cbsa.identifier}
        >
          {statename}
        </LinkButton>
      </div>
      {/* Rate column */}
      <div className={statStyles.columnRate}>{forecastValue.toFixed(3)}</div>

      {/* Change column */}
      <div className={statStyles.columnChange}>
        <span className={statStyles.changeIcon}>
          {getVectorImage(isChanged)}
        </span>
        <span
          className={isChanged ? styles.percentageRed : styles.percentageGreen}
        >
          {Math.abs(padded)}%
        </span>
      </div>
    </div>
  )
}

const CbsaStats = ({
  cbsaJson,
  cbsaData,
  chartRef,
  mapOptions,
  toggleEnabled,
}) => {
  const { displayDate, searchFilter, setSearchFilter } = useGeoState()
  const [getFilter, setfilter] = useState('down')

  function sortStatesByForecastValue(obj, direction = 'asc') {
    if (!obj || typeof obj !== 'object') return obj

    const entries = Object.entries(obj)
    const isStateCode = (key) => /^[A-Z]{2}$/.test(key)

    const metaEntries = []
    const stateEntries = []
    const nonNumericStateEntries = []

    for (const [key, value] of entries) {
      if (!isStateCode(key)) {
        metaEntries.push([key, value])
        continue
      }

      const fv = value?.forecast_value
      if (typeof fv === 'number' && Number.isFinite(fv)) {
        stateEntries.push([key, value])
      } else {
        nonNumericStateEntries.push([key, value])
      }
    }

    // Sort by forecast_value
    stateEntries.sort((a, b) => {
      const av = a[1].forecast_value
      const bv = b[1].forecast_value
      return direction === 'desc' ? bv - av : av - bv
    })

    const sortedObj = Object.fromEntries([
      ...metaEntries,
      ...stateEntries,
      ...nonNumericStateEntries,
    ])

    return sortedObj
  }

  const sortBy = (action) => {
    const statesObj = cbsaData[displayDate]
    if (action === 'up') {
      setfilter('down')
      // stateData[displayDate].sort((a, b) => b.datavalue - a.datavalue)
      cbsaData[displayDate] = sortStatesByForecastValue(statesObj, 'asc')
    } else if (action === 'down') {
      setfilter('up')
      //stateData[displayDate].sort((a, b) => a.datavalue - b.datavalue)
      cbsaData[displayDate] = sortStatesByForecastValue(statesObj, 'desc')
    }
  }
  const cbsaDataForDisplayDate = Object.entries(cbsaData[displayDate])
  const aboutText =
    'The Prediction Interval Accuracy is defined in terms of how often the forecasted prediction interval contains the true Actual value (Last Flu Season).'

  const inputRef = React.useRef(false)
  let isCancelled = React.useRef(false)
  const [btnSearchLocation, setBtnSearchLocation] = React.useState(false)
  let accuracy = 0
  const mappedCbsaData = cbsaDataForDisplayDate.map((cbsa) => {
    const filteredCbsa = cbsaJson?.features?.filter((c) => {
      return c.properties.geoid.toString() === cbsa[0].toString()
    })
    let cityName
    try {
      cityName =
        (
          filteredCbsa?.[0]?.properties?.name ??
          filteredCbsa?.[0]?.properties?.NAME
        )?.split(',')?.[0] ?? ''
    } catch {
      console.log(`exception occured ats ${filteredCbsa[0]}`)
    }

    return { ...cbsa[1], name: cityName, identifier: cbsa[0] }
  })
  const handleChange = (event) => {
    setSearchFilter(event.target.value)
  }

  if (mappedCbsaData[1].forecast_ci_revised_95_overall !== 0) {
    accuracy = mappedCbsaData[1].forecast_ci_revised_95_overall
  }
  let filteredCbsaData = mappedCbsaData
  if (searchFilter !== '') {
    // eslint-disable-next-line array-callback-return
    filteredCbsaData = mappedCbsaData.filter((cbsa) => {
      if (
        cbsa.name &&
        cbsa.name.toLowerCase().includes(searchFilter.toLowerCase())
      ) {
        return cbsa
      }
    })
  }
  // eslint-disable-next-line array-callback-return
  filteredCbsaData = filteredCbsaData.filter((cbsa) => {
    if (cbsa.name && cbsa.name.length > 1) {
      return cbsa
    }
  })
  function showSearch() {
    //console.log(isCancelled);
    isCancelled.current = true
    btnSearchLocation ? setBtnSearchLocation(false) : setBtnSearchLocation(true)
    btnSearchLocation ? setSearchFilter('') : (inputRef.current = false)
    //btnSearchLocation ? inputRef.current.focus() : inputRef.current.focus()
  }
  return (
    <div className={styles.base}>
      <div className={styles.header}>
        <div
          style={{
            width: '100%', //'95%',
            justifyContent: 'flex-start',
          }}
        >
          <div style={{ display: 'flex' }}>
            <div
              style={{
                display: 'inline-flex',
                width: '70%',
              }}
            >
              <span>
                <h5
                  style={{
                    fontFamily: 'graphik',
                    fontSize: '21px',
                    fontWeight: '600',
                    color: '#002677',
                  }}
                >
                  Metro Area Incidence
                </h5>
              </span>
            </div>
            <div
              style={{
                display: 'inline-flex',
                width: '30%',
                justifyContent: 'right',
              }}
            >
              <span onClick={showSearch}>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.3584 10.8862L18 17.01L17.0701 18L10.3724 11.7859C9.26916 12.7439 8.21615 13.0355 6.64841 13.0355C3.10647 13.0355 0.203247 10.1323 0.203247 6.59032C0.203247 3.04838 3.10647 0.145157 6.64841 0.145157C10.1903 0.145157 13.0936 3.04838 13.0936 6.59032C13.0936 8.36129 12.5197 9.7249 11.3584 10.8862ZM6.78389 1.45483C4.03637 1.45483 1.78389 3.70175 1.78389 6.44249C1.78389 9.20792 4.03637 11.4548 6.78389 11.4548C9.53142 11.4548 11.7839 9.18323 11.7839 6.44249C11.7839 3.70175 9.53142 1.45483 6.78389 1.45483Z"
                    fill="#E40046"
                  />
                </svg>
              </span>
            </div>
          </div>

          <div
            style={{
              fontSize: '12px',
              display: 'flex',
              lineHeight: '16px',
              padding: '1rem 0rem 0px',
            }}
          >
            <span style={{ marginLeft: '0px' }}>
              {' '}
              <Tooltip placement="top" iconHeight="15" iconWidth="15">
                <Content maxWidth="300px" fontSize="12px">
                  <p>{aboutText}</p>
                </Content>
              </Tooltip>
            </span>
            &nbsp; Rate represents the incidence of flu within the population in
            a given week. Change indicates the difference in flu incidence since
            the previous week.{' '}
            {/* <b>
              {mappedStateData[3].forecast_ci_revised_95_overall.toLocaleString(
                undefined,
                {
                  maximumFractionDigits: 2,
                }
              ) === 0
                ? 'NA'
                : mappedStateData[3].forecast_ci_revised_95_overall.toLocaleString(
                    undefined,
                    {
                      maximumFractionDigits: 2,
                    }
                  ) + '%'}
            </b> */}
          </div>
          {btnSearchLocation ? (
            <input
              ref={inputRef}
              type="text"
              onChange={handleChange}
              placeholder="Filter Metro Areas"
            />
          ) : null}
        </div>
        <div
          style={{
            padding: '0rem 0rem',
            paddingBottom: '0.5rem',
            paddingTop: '0.5rem',
            borderTop: '1px solid #424242',
            borderBottom: '1px solid #424242',
            marginTop: '5px',
          }}
        >
          <div style={{ display: 'inline-flex', width: '45%' }}>
            <h4>Metro</h4>
          </div>
          <div
            style={{
              display: 'inline-flex',
              width: '20%',
              justifyContent: 'flex-end',
              cursor: 'pointer',
            }}
          >
            <h4 onClick={() => sortBy(getFilter)}>
              Rate{' '}
              <span style={{ marginLeft: '4px' }}>
                {getVectorImage(getFilter)}
              </span>
            </h4>
          </div>
          <div
            style={{
              display: 'inline-flex',
              width: '20%',
              justifyContent: 'flex-end',
            }}
          >
            <h4>Change</h4>
          </div>
          {/* <div
            style={{
              display: 'inline-flex',
              width: '25%',
              justifyContent: 'flex-middle',
            }}
          >
            <h4>Influenza Levels</h4>
          </div> */}
          {/* <div
            style={{
              display: 'inline-flex',
              width: '38%',
              justifyContent: 'flex-end',
            }}
          >
            <h4>CI Accuracy</h4>
          </div> */}
        </div>
      </div>
      <div style={{ overflow: 'scroll', height: '100%' }}>
        {filteredCbsaData
          //.sort((a, b) => (a.name > b.name ? 1 : -1))
          .map((cbsa) => {
            return (
              <CbsaStat
                cbsa={cbsa}
                key={cbsa.identifier}
                chartRef={chartRef}
                mapOptions={mapOptions}
                cbsaJson={cbsaJson}
                toggleEnabled={toggleEnabled}
              />
            )
          })}
      </div>
    </div>
  )
}

export default CbsaStats
